// extracted by mini-css-extract-plugin
export const wrapper = "equipment-used-module--wrapper--3u35P";